import { AnyAction } from 'redux';
import {
	FETCH_NOTIFICATION_MESSAGE,
	NOTHING_TO_NOTIFY,
} from 'redux/actions/notifications';
import { NotificationState } from '../../types/redux';

const initialState: NotificationState = {
	code: '',
	message: '',
};

export function notificationReducer(
	state: NotificationState = initialState,
	action: AnyAction
): NotificationState {
	switch (action.type) {
		case NOTHING_TO_NOTIFY:
			return {
				code: '',
				message: '',
			};
		case FETCH_NOTIFICATION_MESSAGE:
			return {
				code: action.payload.code,
				message: action.payload.error,
			};
		default:
			return state;
	}
}
